// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c38589f5","488":"4c8eb11b","667":"03db9162"}[chunkId] + ".chunk.js";
};